<template>
	<a :href="disableClick ? undefined : URL" target="_blank">
		<v-list-item elevation="5" outlined two-line @click="$emit('click')">
			<v-list-item-avatar>
				<v-icon color="secondary" v-if='type == "LINKED_IN"'>mdi-linkedin</v-icon>
				<v-icon color="secondary" v-else>mdi-open-in-new</v-icon>
			</v-list-item-avatar>
			<v-list-item-content>					
				<v-list-item-title class="text-wrap">
					{{ title }} 	
				</v-list-item-title>
				<v-list-item-subtitle v-text="URL" />
			</v-list-item-content>
		</v-list-item>
	</a>
</template>

<script>
export default {
	props: {
		title: String,
		type: String,
		URL: String,
		disableClick: Boolean,
		adminMode: Boolean,
	},
}
</script>

<style lang="scss" scoped>
.newsCard {
	width: 100%;
}

a {
	text-decoration: none;
}
</style>